import type { LocationExactnessScope } from "@/entities/place";

interface LocationExactness {
    isExact: boolean;
    level: number | null;
    isAdjacent: boolean;
}

/**
 * Converts level and adjacent flag to LocationExactnessScope value.
 */
export function levelToScope(level: number, isAdjacent: boolean): LocationExactnessScope {
    const suffix = isAdjacent ? "a" : "";
    return `${level}${suffix}` as LocationExactnessScope;
}

/**
 * Converts data-model locationExactness to form LocationExactnessScope value.
 * This is a synchronous operation that doesn't require location data.
 */
export function locationDataModelToScope(exactness: LocationExactness): LocationExactnessScope | null {
    if (!exactness?.isExact || exactness.level === null) {
        return null;
    }

    return levelToScope(exactness.level, exactness.isAdjacent);
}

/**
 * Converts form LocationExactnessScope value to data-model locationExactness.
 * This is a synchronous operation that doesn't require location data.
 */
export function locationScopeToDataModel(scope: LocationExactnessScope | null): LocationExactness {
    if (!scope) {
        return { isExact: false, level: null, isAdjacent: false };
    }

    const isAdjacent = scope.endsWith("a");
    const level = parseInt(scope.replace("a", ""), 10);

    return {
        isExact: true,
        level,
        isAdjacent,
    };
}
